import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export { ScaffolderMetricsCard } from './components/scaffolder-metrics-card/scaffolder-metrics-card';
export { ScaffolderTeamMetrics as ScaffolderTeamMetricsPage } from './pages/scaffolder-team-metrics-page';
export { hasTemplate } from './utils';

export const entityContentScaffolderMetrics: ExtensionDefinition =
  EntityContentBlueprint.make({
    name: 'scaffolder-metrics',
    params: {
      path: '/scaffolder-metrics',
      title: 'Template Metrics',
      filter: { kind: 'Group' },
      loader: async () =>
        import('./pages/scaffolder-team-metrics-page').then(m => (
          <m.ScaffolderTeamMetrics />
        )),
    },
  });

export const entityCardScaffolderMetrics: ExtensionDefinition =
  EntityCardBlueprint.make({
    name: 'scaffolder-metrics',
    params: {
      loader: async () =>
        import('./components').then(m => <m.ScaffolderMetricsCard />),
    },
  });
